import { gql } from "@apollo/client";

export const FETCH_SUPPLIERS = gql`
  query FETCH_SUPPLIERS(
    $statesIn: [String]
    $forOnboarding: Boolean
    $withRanking: Boolean
    $hasOdooPartners: Boolean
  ) {
    suppliers(
      statesIn: $statesIn
      forOnboarding: $forOnboarding
      withRanking: $withRanking
      hasOdooPartners: $hasOdooPartners
    ) {
      id
      nickName
      state
      supplierClass
      odooPartners {
        id
      }
      user {
        id
        email
      }
      contactPerson
      phone
      email
      contactAddress
      trackingLabel
      certificates
      mainProducts
      createdAt
      creator {
        id
        email
      }
    }
  }
`;

export const FETCH_SUPPLIER_FOR_ONBOARDING = gql`
  query FETCH_SUPPLIER_FOR_ONBOARDING($id: ID!) {
    factory(id: $id) {
      id
      state
      nickName
      nameEn
      nameCn
      user {
        email
      }
      initialPassword
      draftData
      supplierClass
      signedNdaFileUrl

      odooPartners {
        id
        company
        odooId
      }
    }

    supplierLatestReview(supplierId: $id) {
      state
      currentStep {
        id
      }
      stepStates
      assignments
      review {
        id
        steps {
          id
          name
          description
          order
          condition
          assignments {
            id
            user {
              id
              firstName
            }
            result
            updatedAt
          }
        }
      }
    }
  }
`;

export const CREATE_SUPPLIER = gql`
  mutation CREATE_SUPPLIER(
    $nickName: String!
    $supplierClass: Int!
    $signedNdaFileUrl: String
    $email: String!
    $initialPassword: String!
  ) {
    createSupplier(
      nickName: $nickName
      supplierClass: $supplierClass
      signedNdaFileUrl: $signedNdaFileUrl
      email: $email
      initialPassword: $initialPassword
    ) {
      supplier {
        id
      }
    }
  }
`;

export const SUBMIT_SUPPLIER_REVIEW = gql`
  mutation SUBMIT_SUPPLIER_REVIEW(
    $stepId: ID!
    $result: String!
    $remark: String
  ) {
    submitSupplierReview(stepId: $stepId, result: $result, remark: $remark) {
      supplier {
        id
        state
      }
    }
  }
`;

export const SUPPLIER_RESET_TO_DRAFT = gql`
  mutation SUPPLIER_RESET_TO_DRAFT($id: ID!) {
    supplierResetToDraft(id: $id) {
      supplier {
        id
        state
      }
    }
  }
`;

export const SUPPLIER_COMPLETE_ONBOARDING = gql`
  mutation SUPPLIER_COMPLETE_ONBOARDING($id: ID!) {
    supplierCompleteOnboarding(id: $id) {
      supplier {
        id
        state
      }
    }
  }
`;
